export const intl = {
    en: {
        language: 'Language',
        allOk: 'All Systems Operational',
        someError: 'Some Systems unavailable',
        lastRefresh: 'Status refreshed {mins} minutes ago',
        lastRefresh0: 'Status refreshed seconds ago',
        notWorking: 'Outage',
        working: 'Operational',
        console: 'Operator console logging in time',
        api: 'BotMaker API response time',
        webchat: 'WebChat loading time',
        messenger: 'User questions response time',
        metrics: 'System Metrics',
        avg: 'Average response time'
    },
    es: {
        language: 'Idioma',
        allOk: 'Todos los sistemas activos',
        someError: 'Algunos sistemas no disponibles',
        lastRefresh: 'Status actualizado hace {mins} minutos',
        lastRefresh0: 'Status actualizado hace segundos',
        notWorking: 'Funcionamiento anormal',
        working: 'Funcionamiento normal',
        console: 'Consola del Operador',
        api: 'Tiempo de respuesta API BotMaker',
        webchat: 'WebChat tiempo de carga',
        messenger: 'Tiempo de respuesta a preguntas del usuario',
        metrics: 'Métricas de sistemas',
        avg: 'Tiempo de respuesta promedio'
    },
    pt: {
        language: 'Idioma',
        allOk: 'Todos os sistemas estão ativados',
        someError: 'Alguns sistemas não estão disponíveis',
        lastRefresh: 'Status atualizado há {mins} minutos',
        lastRefresh0: 'Status atualizado há segundos',
        notWorking: 'Funcionamento anormal',
        working: 'Funcionamento normal',
        console: 'Logon da consola do operador no tempo',
        api: 'Tempo de resposta da API de BotMaker',
        webchat: 'WebChat tempo de carregamento',
        messenger: 'Tempo de resposta às perguntas do usuário',
        metrics: 'Métricas do sistema',
        avg: 'Tempo médio de resposta'
    }
};
